<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import { devices, rooms } from 'src/stores';
	import {
		consumption_by_device_account,
		consumption_device,
		consumption_rooms,
	} from 'src/stores/features/consumption';
	import EmDeviceEnergyTrend from 'src/components/EnergyMonitoring/sections/EmDeviceEnergyTrend.svelte';
	import { energyMonitoringDataMode } from 'src/components/EnergyMonitoring/helpers/store';
	import { getControlsForEnergyConfig } from 'src/components/Dashboards/dash-energy-period';
	import { buildConsumptionStores } from 'src/components/EnergyMonitoring/helpers/consumption_helpers';
	import { resolveConsumerDeviceIds } from 'src/components/EnergyMonitoring/helpers/energy_widget_state_helpers';
	import type { DashEnergyWidgetConfig } from 'src/components/Dashboards/dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig | undefined;
	export let staticPreview = false;

	$: config = energyConfig ?? { period: 'live' };
	$: controls = getControlsForEnergyConfig(config);
	$: requestedDeviceId = (config as { deviceId?: string }).deviceId;
	$: useDemoData = staticPreview || $energyMonitoringDataMode === 'demo';
	$: consumptionStores = buildConsumptionStores({
		rooms: $rooms,
		devices: $devices,
		consumptionRooms: $consumption_rooms,
		consumptionDevice: $consumption_device,
		consumptionByDeviceAccount: $consumption_by_device_account,
	});
	$: consumerDeviceIds = resolveConsumerDeviceIds(consumptionStores, $devices, $rooms, useDemoData);
	$: selectedDeviceId =
		(requestedDeviceId && $devices[requestedDeviceId] ? requestedDeviceId : undefined) ??
		consumerDeviceIds[0];
	$: fallbackDeviceIdsKey = requestedDeviceId ? '' : consumerDeviceIds.join(',');
</script>

<EmDeviceEnergyTrend
	deviceId={selectedDeviceId}
	{fallbackDeviceIdsKey}
	{controls}
	periodId={config.period}
	{staticPreview}
/>
